export const setCookiesPolicyData = () => {
  return <div>
    <div className='px-3'>
      <div className="cx--contact-info-wrapper">
        <small className="d-block cx--contact-info-text">Cryllex Inc.</small>
        <small className="d-block cx--contact-info-text">Last Updated: December 23rd, 2022</small>
      </div>

      <div id="overview" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">OVERVIEW</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            The Cookie Policy describes the different types of cookies that may be applied by Cryllex Global Inc.
            on its website (“Site”). We reserve the right to modify this Cookie Policy at any time in order to reflect,
            for example, changes to the cookies we use or for other operational, legal or regulatory reasons
          </span>
          <span className='d-block my-3'>
            If you have any questions regarding this Cookie Policy, please contact us at info@cryllex.com.
          </span>
        </div>
      </div>

      <div id="whatAreCookies" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">WHAT ARE COOKIES</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cookies are a standard feature of websites that allow us to store small amounts of data on your
            computer about your visit to a website. Cookies help the website owner learn which areas of the
            website are useful and which areas need improvement. Cookies also improve your experience by, for
            example, remembering your preferences, such as your language preference or login information.
          </span>
          <span className='d-block my-3'>
            Some cookies are required for technical reasons in order for a website to operate, also known as
            “Strictly Necessary” cookies. Some cookies allow a website to count visits and traffic sources so the
            site owner can measure and improve the performance of the site, also known as “Analytics” cookies.
            Some cookies enable a website owner to serve targeted advertisements, also known as “Targeting”
            cookies.
          </span>
        </div>
      </div>

      <div id="cookiesWeUse" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">COOKIES WE USE</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Our Site uses both first party cookies (which are determined by us) and third party cookies (which are
            determined by a server located outside the domain of our Site) for several reasons. The specific types
            of first and third party cookies served through our Site and the purposes they perform are described
            in the tables below.
          </span>
          <span className='d-block mt-3'>
            Strictly Necessary Cookies. These are cookies which make our Site function when you take certain
            actions, whether you are logging in, managing email preferences, or filling out forms. Since they are
            essential for our Site to function, we cannot turn them off. You can set your browser to block or alert
            you about these cookies, but some parts of the Site will then not work. These cookies do not store
            personal data.
          </span>
        </div>

        <div className='table-responsive table-bordered mt-2'>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col" className='text-center'>Cookie Name</th>
                <th scope="col" className='text-center'>Purpose</th>
                <th scope="col" className='text-center'>First vs. Third Party</th>
                <th scope="col" className='text-center'>Expiration</th>
              </tr>
            </thead>
            <tbody>
              <tr className='border'>
                <td style={{ minWidth: "200px" }}>Cloudflare(_cfduid)</td>
                <td style={{ minWidth: "200px" }}>
                  Cloudflare provides
                  content-delivery-network services,
                  DDos mitigation, Internet security,
                  and distributed
                  domain-name-server services. This
                  cookie collects and anonymizes end
                  user IP addresses using a one-way
                  hash of certain values so they
                  cannot be personally identified.
                </td>
                <td style={{ minWidth: "200px" }}>Third Party</td>
                <td style={{ minWidth: "200px" }}>Session</td>
              </tr>

              <tr className='border'>
                <td style={{ minWidth: "200px" }}>Connect_Sid</td>
                <td style={{ minWidth: "200px" }}>This cookie is used to identify or create a valid user session.</td>
                <td style={{ minWidth: "200px" }}>First Party</td>
                <td style={{ minWidth: "200px" }}>Session</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="cx--contact-info-text mt-2">
          <span>
            Analytics Cookies. These cookies allow us to count visits and traffic sources to our Site so we can
            measure and improve the performance of our Site. The information these cookies collect is
            aggregated and anonymous. If you do not allow these cookies, we will not be able to serve you the
            most relevant content and give you the best experience.'
          </span>
        </div>
        <div className='table-responsive table-bordered mt-2'>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col" className='text-center'>Cookie Name</th>
                <th scope="col" className='text-center'>Purpose</th>
                <th scope="col" className='text-center'>First vs. Third Party</th>
                <th scope="col" className='text-center'>Expiration</th>
              </tr>
            </thead>
            <tbody>
              <tr className='border'>
                <td style={{ minWidth: "200px" }}>Google Analytics</td>
                <td style={{ minWidth: "200px" }}>
                  These cookies are used to calculate
                  visitor, session and campaign data
                  for the Sites' analytics reports
                  through aggregated, anonymous
                  user data.
                </td>
                <td style={{ minWidth: "200px" }}>Third Party</td>
                <td style={{ minWidth: "200px" }}>6 months</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="cx--contact-info-text  mt-2">
          <span>
            Targeting Cookies. These cookies may be set through our Site by our marketing partners. They may be
            used by us or our marketing partners to understand which parts of our Sites are of interest to you
            and/or show you relevant advertising on our Site or on other Sites. They do not store personal data,
            but are based on uniquely identifying your browser and internet device. If you do not allow these
            cookies, you will experience less targeted advertising.
          </span>
        </div>
        <div className='table-responsive table-bordered mt-2'>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col" className='text-center'>Cookie Name</th>
                <th scope="col" className='text-center'>Purpose</th>
                <th scope="col" className='text-center'>First vs. Third Party</th>
                <th scope="col" className='text-center'>Expiration</th>
              </tr>
            </thead>
            <tbody>
              <tr className='border'>
                <td style={{ minWidth: "200px" }}>LinkedIn Advertising</td>
                <td style={{ minWidth: "200px" }}>
                  These cookies are used to provide
                  insight into user behavior within
                  LinkedIn that is responsive to our
                  marketing efforts, in order to deliver
                  marketing content to you such as
                  emails, white papers, webinars, etc.
                </td>
                <td style={{ minWidth: "200px" }}>Third Party</td>
                <td style={{ minWidth: "200px" }}>6 months</td>
              </tr>
              <tr className='border'>
                <td style={{ minWidth: "200px" }}>Google AdWords</td>
                <td style={{ minWidth: "200px" }}>
                  These cookies are used to provide
                  insight into behavioral advertising
                  and analytics on the Google
                  AdWorks platform to enable us to
                  serve you with product-based
                  advertisements on external
                  websites.
                </td>
                <td style={{ minWidth: "200px" }}>Third Party</td>
                <td style={{ minWidth: "200px" }}>540 days</td>
              </tr>
              <tr className='border'>
                <td style={{ minWidth: "200px" }}>Facebook Advertising</td>
                <td style={{ minWidth: "200px" }}>
                  These cookies allow us to confirm
                  when you have completed a form or
                  action related to Facebook. Cryllex
                  Global may send you related
                  communications via email or
                  sponsored newsfeed updates.
                </td>
                <td style={{ minWidth: "200px" }}>Third Party</td>
                <td style={{ minWidth: "200px" }}>6 months</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div id="webBeacins" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">WEB BEACONS</strong>
        <div className="cx--contact-info-text mt-2">
          Cookies are not the only way to recognize or track visitors to a website. We may use other, similar
          technologies from time to time, like web beacons (sometimes called “tracking pixels” or “clear gifs”).
          These are tiny graphics files that contain a unique identifier that enable us to recognize when
          someone has visited our Site or opened an email that we sent. This allows us, for example, to monitor
          the traffic patterns of users from one page within our site to another, to deliver or communicate with
          cookies, to understand whether a user came to our Site from an online advertisement displayed on a
          third-party website, to improve site performance, and to measure the success of email marketing
          campaigns. In many instances, these technologies are reliant on cookies to function properly, and so
          declining cookies will impair their functioning.
        </div>
      </div>

      <div id="howToManageCookies" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">HOW TO MANAGE COOKIES</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            You can choose whether to accept our cookies (except Strictly Necessary Cookies) by clicking on the
            appropriate opt-out links in our Cookie Preference Center, which can be found in our Site's footer and
            cookie banner. You also have the right to refuse or accept cookies at any time by activating settings on
            your browser. You may wish to refer to
            &nbsp;<a className='text-nowrap' href='http://www.allaboutcookies.org/manage-cookies/index.html' target="_blank">
              http://www.allaboutcookies.org/manage-cookies/index.html</a>&nbsp;
            for information on commonly used browsers.
            <br />
            Note that blocking some types of cookies may impact your experience on our Site and the services
            we are able to offer you.
          </span>
        </div>
      </div>

    </div>
  </div>
}
export const setPrivacyPolicyData = () => {
  return <div >
    <div className="px-3">
      <div className="cx--contact-info-wrapper">
        <small className="d-block cx--contact-info-text">Cryllex Inc.</small>
        <small className="d-block cx--contact-info-text">Last Updated: December 23rd, 2022</small>
      </div>

      <div id="commitmentToPrivacy" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">COMMITMENT TO PRIVACY</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex Global, Inc. understands that you care about how your personal information is used and
            disclosed and we take your privacy very seriously. Although our primary purpose is to provide you
            with an excellent product and exceptional service, we are committed to protecting your privacy and
            ensuring that information regarding your personal information is readily accessible. To make this
            privacy policy easy to find, we make it available from the home page of the Cryllex website at
            cryllex.com (the “Sites”). You may also refer to the contact us section of our website with any
            privacy-related questions you have.
          </span>
        </div>
      </div>

      <div id="overview" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">OVERVIEW</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            The Privacy Statement (“Statement”, “Notice”, “Policy”) describes the ways Cryllex Global, Inc.
            (“Cryllex”, “we”, “us”, “our”) collects, stores, uses and protects information. This statement applies to all
            information we collect through our services including merchant processing services, websites, mobile
            applications, products and any other features, technologies or functionalities, such as customer
            support (“Services”) offered by us. This Notice applies to cryllex.com and all other Cryllex Global sites
            on which it appears (the “Sites”).
          </span>
          <span className='d-block my-3'>
            Our privacy practices may vary among the countries or territories where we operate to reflect local
            practices and legal requirements. As the Services evolve, we may occasionally update this privacy
            statement to reflect changes to our business, Services, or applicable laws. If the revised version
            requires notice in accordance with applicable law, we will provide you with 30 days prior notice by
            posting notice of the change on the “Privacy Policy” page of our website. Otherwise, the revised
            Privacy Statement will be effective as of the published effective date, and you are responsible for
            periodically reviewing this Notice.
          </span>
          <span className='d-block mt-3'>We may process information from the following types of users:</span>
          <ol className='mt-3'>
            <li>
              Visitors of our Sites;
            </li>
            <li>
              Merchants who sign up for our Services (“Merchants” meaning any business that uses our
              Services to process payments, including non-profits that use our Services to accept donation
              and “Aggregators” that use our Services as payment services platform for their own
              Merchants);
            </li>
            <li>
              Shoppers of Merchants (“Shoppers” meaning individuals who indirectly interface with Cryllex
              Global when paying a Merchant's invoice that is forwarded by Cryllex Global to a Merchant
              during checkout, when requesting a refund from a Merchant, when creating a Cryllex Global
              account, or when making a donation to a non-profit)
            </li>
            <li>
              Payees (e.g. employees, contractors, vendors or exchange customers) who request a payment
              (“Payout”) via cryptocurrency from a Merchant and create a Cryllex Global account.
            </li>
          </ol>
          <span>
            By using the Site or Service, you agree to the collection and use of information in accordance with this
            privacy statement and the applicable user agreement.
          </span>
        </div>
      </div>

      <div id="theInformationWeCollect" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">THE INFORMATION WE COLLECT</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            We collect different kinds of information when users interact with us. The information we collect
            depends on the type of user. We collect information you choose to provide to us when interacting
            with our Services. We may also collect information automatically from your devices. The following
            sections will provide additional information.
          </span>
          <ol>
            <li>
              <p className='mt-4 mb-2 text-underline'>
                Visitors of Our Sites
              </p>
              <span className='d-block'>
                When you visit the website or use one of our services, we collect your IP address and standard
                web log information, such as your browser type and the pages you accessed on our website.
                We may also collect information about a visitor's computer or other access devices for
                purposes including fraud prevention. The information we collect may be collected
                automatically using cookies or other similar technologies. For more information about our use
                of cookies, please refer to our Cookie Policy. If you do not agree to our collection of this
                information, you may not be able to use our Service.
              </span>
              <ul className='mt-3' >

                <li className='list-style-disc'>
                  First and last name (e.g. when you submit a support request)
                </li>

                <li className='list-style-disc'>
                  Email address (e.g. when you subscribe to our blog or opt in to receive other
                  marketing materials)
                </li>

                <li className='list-style-disc'>
                  Phone number (e.g. when you submit a contact request or opt in to our media list)
                </li>

                <li className='list-style-disc'>
                  Country
                </li>

                <li className='list-style-disc'>
                  Technical information, including IP address; the type of browser, devices and
                  operating systems you use; identifiers associated with the device(s) you use to access
                  our Sites; the pages you visit and the features you use; access dates and times; ad if you navigated from or navigate to another website, the address of that website; and
                  information regarding your internet service provider
                </li>

                <li className='list-style-disc'>
                  Other information collected from cookies or other tracking technologies
                </li>

              </ul>
            </li>

            <li>
              <p className='mt-4 mb-2 text-underline'>
                Merchants (including businesses such as nonprofits and Aggregators)
              </p>
              <span className='d-block'>
                During the onboarding process, we may collect the following information of the beneficial
                owner or any user that is added to an account of a Merchant (including nonprofits and
                Aggregators that use our Services as a payment services platform for their own Merchants).
                For Aggregators, we may collect the information of that Aggregator's Merchants.
              </span>
              <span className='d-block mt-3'>
                The element we collect depends on our compliance analysis and the client risk profile; some
                include:
              </span>
              <ul className='mt-3' >

                <li className='list-style-disc'>
                  Personal information of beneficial owner(s) and authorized user(s), including full
                  name, personal email address, and phone number;
                </li>

                <li className='list-style-disc'>
                  Government identification of beneficial owner(s) and authorized user(s), such as a
                  government issued passport or driver's license, as well as Tax identification number (if
                  applicable according to country laws and regulations);
                </li>

                <li className='list-style-disc'>
                  Corporate information, such as merchant email address (business domain preferred),
                  full physical address (no post office boxes allowed), and business telephone number;
                </li>

                <li className='list-style-disc'>
                  Company bank account details;
                </li>

                <li className='list-style-disc'>
                  Three most recent bank statements or bank letter of good standing, proof of business,
                  and proof of address (if applicable)
                </li>

              </ul>
              <span className='d-block mt-3'>
                We may use this information for risk management purposes (i.e. to verify Merchant’s identity
                or address) or to comply with laws and regulation, including those applicable to financial
                services institutions. We may also obtain information about our Merchants from third parties
                that provide identity verification and fraud prevention services and from relevant Aggregators.
              </span>
            </li>

            <li>
              <p className='mt-4 mb-2 text-underline'>
                Shoppers of Merchants
              </p>
              <span className='d-block'>
                We may collect information when a Shopper indirectly interfaces with our Services to pay a
                Merchant's invoice, request a refund and/or make donations, or creates a consumer account
                through our Website:
              </span>
              <ul className='mt-3' >
                <li className='list-style-disc'>
                  When you pay a Cryllex Global invoice, we collect:
                  <ul>
                    <li className='list-style-circle'>
                      Identification information, such as your first and last name, email address, and
                      cryptocurrency wallet address
                    </li>

                    <li className='list-style-circle'>
                      Age or date of birth and citizenship through Government-issued identification
                      (if applicable based on local laws and legislations)
                    </li>

                    <li className='list-style-circle'>
                      Information that identifies with reasonable specificity your location by using,
                      for instance, longitude and latitude coordinates obtained through GPS, Wi-Fi,
                      or cell site triangulation.
                    </li>

                    <li className='list-style-circle'>
                      Technical information including IP addresses used to view the invoice; the
                      type of browser, devices and operating systems you use; identifiers associated
                      with the device(s) you use to access our sites; the pages you visit and the
                      features you use; access dates and times; and if you navigated from or
                      navigate to another website, the address of that website; and information
                      regarding your internet service provider
                    </li>

                    <li className='list-style-circle'>
                      Other information collected from cookies or other tracking technologies
                    </li>

                    <li className='list-style-circle'>
                      Order and product information at the relevant merchant
                    </li>

                  </ul>
                </li>

                <li className='list-style-disc'>
                  When you request a refund, we collect:
                  <ul>

                    <li className='list-style-circle'>
                      Information related to the relevant transaction, such as the amount, currency,
                      and invoice ID
                    </li>

                    <li className='list-style-circle'>
                      Personal information, such as your email address and crypto wallet address.
                    </li>

                  </ul>
                </li>

                <li className='list-style-disc'>
                  Certain Shoppers may choose to or may be required to create a Cryllex account; in
                  doing so, we may collect additional information from you.
                </li>

              </ul>
              <span className='d-block mt-4'>
                We may collect this information either from the Merchant or directly from the Shopper.
                Collecting this information supports our ability to provide our Services. This enables our
                system to send an email to Shoppers directly to obtain a cryptocurrency refund address in
                case of a payment exception (e.g. overpayments, underpayments, etc.). This also creates a
                more seamless payment experience for both the Merchant and the Shopper.
              </span>
              <span className='d-block my-3'>
                Additionally, upon the Merchant's explicit request, we may collect and store information for
                the Merchant's benefit only and as a service through our invoicing service. Information that
                Merchants may request about Shoppers may include:
              </span>
              <ul className='mt-3' >

                <li className='list-style-disc'>
                  Personal information such as first and last name, address, email address, and crypto
                  wallet address
                </li>

                <li className='list-style-disc'>
                  Transaction information such as the transaction identification number and details.
                </li>

              </ul>
            </li>

            <li>
              <p className='mt-4 mb-2 text-underline'>
                Payees of Merchants
              </p>
              <span className='d-block'>
                Cryllex Global offers a service for Merchants to pay individuals (employees, contractors,
                vendors and exchange customers) via cryptocurrency (“Payees”).
              </span>
              <span className='d-block my-3'>
                The following information may be collected from Payees in certain instances:
              </span>
              <ul className='mt-3' >
                <li className='list-style-disc'>Personal information, such as first and last name, email address, and cryptocurrency wallet address/provider</li>
                <li className='list-style-disc'>Identification documents, such as a government issued passport or driver's license</li>
                <li className='list-style-disc'>Official documentation showing proof of address, such as a bank statement or a utility bill.</li>
              </ul>
            </li>

            <li>
              <p className='mt-4 mb-2 text-underline'>
                Additional Collection
              </p>
              <span className='d-block'>
                Cryllex Global may collect additional information in connection with its efforts to combat
                fraud, illegal activity, or comply with laws and regulations. Additionally, Cryllex Global may
                collect information regarding the effectiveness of our email and other communications. For
                example, we may know if you follow a link in an email we send to you. We may also obtain
                information about you from other third parties. This may include information about your use
                of this Site or our Services. We may also collect information about former, existing and
                prospective vendors and customers (“Partners”). This includes limited personal information
                about employees and agents of such Partners (“Partner Employees”) at the beginning and
                throughout the course of the Partner relationships, such as professional contact information.
              </span>
            </li>
          </ol>
        </div>
      </div>

      <div id="howWeUseCookies" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">HOW WE USE COOKIES</strong>
        <p className="cx--contact-info-text mt-2">
          <span>
            When you visit or use our Services,or visit a third-party website for which we provide online services,
            we and certain business partners and vendors may use cookies, clear GIFS or web beacons, or other
            identifiers or tracking technologies to collect information aboutWe may collect information about
            your activities on our sites. We refer to these technologies collectively as “cookies”.
          </span>
          <span className='d-block my-3'>
            We may allow third parties to use cookies on our sites. The information collected by cookies may be
            shared with and used by us, by others acting on our behalf, or by third pirates subject to their own
            privacy policies. Information collected by cookies may be used on this site or on other websites or
            services, including those that may not be operated by us. Other parties may collect personally
            identifiable information about an individual consumer's online activities over time and across different
            websites when a consumer uses our websites or online services. For more information about our use
            of cookies, please refer to our Cookie Policy.
          </span>
          <span className='d-block my-3'>
            You can control the use of cookies at the individual browser level. If you reject cookies, you may still
            use our website, but your ability to use some features or areas of our website may be limited. You may
            control how your browser accepts cookies. For more information, please consult your browser's help
            documentation. You may also manage your cookie preferences using our Cookie Preference Center.
            For more information about our use of cookies, please refer to our Cookie Policy.
          </span>
          <span className='d-block my-3'>
            Certain Services are only available through the use of cookies, so if you choose to disable or decline
            cookies, your use of certain Services may be limited or not possible.
          </span>
          <span className='d-block my-3'>
            As of the last updated date of this Notice, there is no commonly accepted response for Do Not Track
            signals initiated by browsers. Therefore, we do not respond to such signals or to other mechanisms
            that provide the ability to exercise choice regarding the collection of personally identifiable
            information regarding your online activities over time and across third-party websites or online
            services.
          </span>
          <span className='d-block my-3'>
            If you do not wish to receive marketing communications from us, you can click the “unsubscribe” link
            usually found at the bottom of the email, or you can send an email to info@cryllex.com. However, you
            may still receive other communications from us as permitted or required by law.
          </span>
        </p>
      </div>

      <div id="howWeUseThePersonalInfo" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">HOW WE USE THE PERSONAL INFORMATION WE COLLECT</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            We primarily use the information we collect to provide you with a safe, smooth, efficient, and
            customized experience. Specifically, we may use your personal information to:
          </span>
          <ul className='mt-3'>
            <li>
              Run our sites and better provide the services and customer support you request, for example
              to help you make purchases, show you your account information, verify access to your
              account, and keep your account information up to date.
            </li>
            <li>
              Process transactions and send notices about your transactions or network activity;
            </li>
            <li>
              Resolve disputes, collect fees, and troubleshoot problems;
            </li>
            <li>
              Protect our business and our customers by using it to prevent potentially fraudulent,
              prohibited or illegal activities, and enforce our User Agreement through the use of our risk and
              fraud tools which may include use of the information you provide;
            </li>
            <li>
              Communicate with you about our Services and business and to inform you of matters that are
              important for your account and/or use of the Sites
            </li>
            <li>
              Respond to any questions, comments or requests you filed with us and the handling of any
              complaints;
            </li>
            <li>
              Establish, exercise and defend legal claims;
            </li>
            <li>
              Monitor and report compliance issues;
            </li>
            <li>
              Customize, measure and improve our business , the Services, and the content and layout of
              our website and applications (including developing new products and services; managing our
              communications; determining the effectiveness of our sales, marketing and advertising;
              analyzing and enhancing our products, services, websites and apps; ensuring the security of
              our networks and information systems; performing accounting, auditing, invoicing,
              reconciliation and collection activities; and improving and maintaining the quality of our
              customer services);
            </li>
            <li>
              Perform data analysis;
            </li>
            <li>
              Deliver targeted marketing, service update notices, and promotional offers based on your
              communication preferences. To approach you via email for marketing purposes, we request
              your consent, unless it is not required by law. You always have the option to unsubscribe from
              our mailings (e.g. via the unsubscribe link in our newsletter);
            </li>
            <li>
              Perform risk management, including comparing information for accuracy and verify it with
              third parties and protect against, identify and prevent fraud and other prohibited or illegal
              activity, claims and other liabilities; and
            </li>
            <li>
              Enforce our contractual terms.
            </li>
            <li>
              Perform other duties as required by applicable laws and regulations.
            </li>
          </ul>
        </div>
      </div>

      <div id="howWeProtectAndStorePersonalInfo" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">HOW WE PROTECT AND STORE PERSONAL INFORMATION</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            We take the security of our information very seriously. We use administrative, technical and physical
            security designed to safeguard personal information in our possession, and we maintain internal
            policies and procedures to address our data security. We store and process your personal information
            using third party servers located in data centers in ____. This information is protected by physical,
            electronic and procedural safeguards in compliance with the applicable laws and legislations. We also
            use computer safeguards such as firewalls and data encryption and authorize access to personal
            information only for those employees who require it to fulfill their job responsibilities.
          </span>
          <span className='d-block my-3'>
            We strive to ensure the highest level of security, confidentiality, and availability. However, we cannot
            guarantee that personal information may not be accessed, disclosed, altered, or destroyed by breach
            of our administrative, managerial, and technical safeguards. Therefore, we urge you to take adequate
            precautions to protect your personal information as well, including never sharing your Cryllex
            password with anyone.
          </span>
          <span className='d-block my-3'>
            We will notify users electronically in the event of a data breach so that you can take appropriate
            protective steps. By using the Services, you agree that Cryllex may communicate with you
            electronically. We will also notify the relevant authorities in the event of a data breach if required
            under applicable law. For example, as a regulated financial institution, we may retain identification for
            5 years or more after an account has been closed or become dormant, unless we need to keep it
            longer, such as:
          </span>
          <ul className='mt-3'>
            <li>
              A legal obligation or compliance to laws which we are subject is retained consistent with the
              applicable law, such as under Anti-Money Laundering obligations
            </li>
            <li>
              Litigation, investigations, audit, and compliance practices, or to protect against legal claims.
            </li>
          </ul>
        </div>
      </div>

      <div id="howWeShareDataWithThirdParties" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">HOW WE SHARE DATA WITH THIRD-PARTIES</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex does not disclose your personal information with third parties for their promotional or
            marketing purposes.
          </span>
          <span className='d-block my-3'>
            We may disclose the information we gather with our affiliates and third parties. For example, we may
            share information with:
          </span>
          <ul className='mt-3'>
            <li>
              Other Cryllex Global entities, including to help detect and prevent potentially illegal acts and
              violations of our policies, and to guide decisions about our products, services and
              communications;
            </li>
            <li>
              Service providers under contract who help with our business operations and to deliver our
              Services, such as cloud service providers providing cloud infrastructure; providers of ID
              verification solutions and other due diligence solutions; providers of customer service
              solutions; providers of website analytics; and providers of marketing automation platforms;
            </li>
            <li>
              Law enforcement, government officials, regulatory agencies, our banks, and other third parties
              pursuant to a subpoena, court order or other legal process or requirement if applicable to
              Cryllex Global; or when we believe, in our sole discretion, that the disclosure of information is
              necessary to report suspected illegal or fraudulent activity or to investigate violations of our
              Terms of Use; and
            </li>
            <li>
              We may also share certain Shopper information with our Merchants, for example, in cases of
              suspected fraud or in connection with an ongoing investigation.
            </li>
          </ul>
          <span className='d-block mt-3'>
            Please note that these third parties may be in other countries where the laws on processing
            information may be less stringent than in your country.
          </span>
        </div>
      </div>

      <div id="contactInfo" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">CONTACT INFORMATION</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            You may contact us with questions or concerns about our privacy policies or practices at
            info@cryllex.com. If you wish to submit a data privacy rights request, you may do so by emailing us at
          </span>
          &nbsp;
          <a to='#' className='text-nowrap'>info@cryllex.com</a>.
        </div>
      </div>

    </div>
  </div>
}

export const setFaqData = () => {
  return <div >
    <div className="px-3">
      <div id="block_1" className="cx--contact-info-wrapper mt-2">
        <strong className="cx--section-title-lg">What does Cryllex do?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex is a payment software provider helping businesses make cheaper and faster cross-border payments compared to conventional alternatives such as via SWIFT, credit cards, etc.
          </span>
          <span className='d-block my-2'>
            Cryllex aims to develop and integrate digital payment solutions into existing financial systems to revolutionize the way businesses make and receive payments on a global scale. We bridge the gap between traditional businesses and the benefits of the impending financial future.
          </span>
        </div>
      </div>
      <div id="block_2" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">Who can transact using Cryllex?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex’s services are available to individuals, businesses, and governments alike. Ranging from One-Time Instant Payments to an eCommerce Merchant Checkout Solution, Cryllex equips you with an array of solutions to satisfy your unique payment needs.
          </span>
          <span className='d-block my-2'>
            If you have any specific questions surrounding the applicability of Cryllex’s services or need a tailored business solution, feel free to send us an email at <a href="mailto:helpdesk@cryllex.com">helpdesk@cryllex.com</a> and our team will get back to you shortly!
          </span>
        </div>
      </div>
      <div id="block_3" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">Who can transact using Cryllex?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex services most major, emerging and minor hubs around the world, including jurisdictions in Asia to the Americas to Europe.
          </span>
          <span className='d-block my-2'>
            Cryllex Payers can make payments from anywhere with an internet connection and a mobile device. As for Cryllex Payees, excluding those featured in global sanction lists (e.g. UN sanctions list), Cryllex offers local bank settlement in over 70 countries denominated in a variety of currencies for your choosing.
          </span>
        </div>
      </div>
      <div id="block_4" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">What are the advantages of transacting via Cryllex?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            All our solutions facilitate cost-efficient, fast and secure cross-border payments. Our technology also offers businesses direct exposure to a nascent and rapidly growing asset class, expanding your global consumer base.
          </span>
          <span className='d-block my-2'>
            Curious as to how Cryllex can elevate your specific payment demands? Contact us at <a href="mailto:helpdesk@cryllex.com">helpdesk@cryllex.com.</a>
          </span>
        </div>
      </div>
      <div id="block_5" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">How long do Cryllex payments take to process?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Payments made through Cryllex are settled instantaneously to your Cryllex balance, reducing payment and cash flow uncertainties that often delay business processes. The process of withdrawing funds to your registered bank account typically takes 1 business day, depending on the time from the designated daily settlement cutoff time and your settlement settings selections.
          </span>
        </div>
      </div>
      <div id="block_6" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">What is Cryllex’s transaction fee structure? Will I be subject to any hidden fees?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Built with our customers in mind, Cryllex does not charge any additional startup fees, exchange rate markup fees, intermediary bank fees, etc.
          </span>
          <span className='d-block my-2'>
            For reference, the average $5000 USDT payment made via Cryllex is only subject to ~0.8% of the total transaction value, which comes out to ~$40 USDT. Aside from the core fees that make Cryllex’s services possible, Payers pay the quoted amount and nothing more. Cryllex transaction fees are set to be reduced to ~0.5% in our v2 launch – stay connected for further updates!
          </span>
          <span className='d-block my-2'>
            To receive a quote for your specific payment circumstance (transaction value, settlement jurisdiction and currency, etc.), send an email to <a href="mailto:helpdesk@cryllex.com">helpdesk@cryllex.com</a>helpdesk@cryllex.com and our representatives will provide a tailored breakdown as soon as possible.
          </span>
        </div>
      </div>
      <div id="block_7" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">How competitive are Cryllex’s fees compared to traditional alternatives?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex was created to address the increasing strain on businesses due to high transaction fees charged by credit cards and other traditional payment methods. While credit card networks charge an average ~3% of total transaction value, Cryllex Paying Customers pay ~0.8% on average -- a significant reduction so Payers can retain a greater portion of their earnings.
          </span>
        </div>
      </div>
      <div id="block_8" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">Are Cryllex Payees (Merchants) subject to any transaction fees?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Contrary to most other B2B payment alternatives who charge the recipient a sizeable percentage of the total transaction value, Cryllex only charges a small, flat, fee depending on the Merchant’s settlement settings selections.
          </span>
          <span className='d-block mt-2'>
            Please note that if you do not want settlement in USD, you may be subject to FX fees. Even with FX fees, however, Cryllex Merchants typically pay no more than ~0.2% of the total transaction value.
          </span>
        </div>
      </div>
      <div id="block_9" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">Which digital assets and blockchain networks does Cryllex support?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            At present, Cryllex accepts payments made in USD stablecoins (pegged to USD, 1:1), namely USDT and USDC. However, Cryllex’s technology is built to support a wide variety of coins and tokens – soon, Cryllex will support payments made in other cryptocurrencies, such as BTC, ETH, SOL, alongside stablecoins pegged to other local fiat currencies such as the HKD, SGD, THB, etc.
          </span>
          <span className='d-block mt-2'>
            At present, Cryllex supports the following blockchain networks: Ethereum, Base, BSC, Optimism, Polygon, Avalanche, Tron, Solana and Arbitrum.
          </span>
        </div>
      </div>
      <div id="block_10" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">As a Payee (Merchant), what currencies can I receive settlement in?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            For those on the receiving end of Cryllex payments, money is settled directly into your local bank account in a multitude of global fiat currencies of your choice. Please note that the desired fiat settlement currency is conditional upon your settlement region.
          </span>
          <span className='d-block mt-2'>
            Cryllex is constantly expanding its settlement capabilities. Log-in to your Cryllex Merchant Portal to see Cryllex’s supported settlement countries
          </span>
        </div>
      </div>
      <div id="block_11" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">How does the Merchant (Payee) Cryllex balance settlement process work?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            The settlement process is a two-step procedure:
          </span>
          <span className='d-block mt-2'>
            Firstly, when submitting a Merchant Payout Request (settlement request), Merchants are required to withdraw the full amount of their balance in Cryllex – presently, Cryllex does not allow Merchants to withdraw a certain portion of their Cryllex balance.
          </span>
          <span className='d-block mt-2'>
            Secondly, if the Merchant Cryllex balance exceeds $5000 USD in value, Merchants are required to withdraw their Cryllex balance to their bank account once per 24 hours, at a minimum (automated procedure). If the Merchant Cryllex balance does not exceed $5000 USD in value, Merchants are given the option to let their Cryllex balance accrue up to the $5000 USD value limit.
          </span>
        </div>
      </div>
      <div id="block_12" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">During Cryllex balance withdrawal, what pathways are used for bank account settlement?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            When processing Merchant Payout Requests, Cryllex offers 2 types of settlement pathways – a local settlement rail and a traditional settlement rail. The local settlement rails are Cryllex’s default settlement pathway, enabling our Merchants to settle fiat currency quicker and up to 5 times cheaper than its counterpart.
          </span>
          <span className='d-block mt-2'>
            With that said, considering the unique circumstances of each of those within our diverse client base, Cryllex continues to offer a traditional alternative to Merchants for additional flexibility.
          </span>
          <span className='d-block mt-2'>
            To learn more about the specifics, sign-up to become a Merchant or send us an email at <a href="mailto:helpdesk@cryllex.com">helpdesk@cryllex.com.</a>
          </span>
        </div>
      </div>
      <div id="block_13" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">Do I need to register as a Paying Customer to make payments via Cryllex?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Paying Customers can make up to 3 payments per day, with each payment not exceeding $800 USD in value, without onboarding with Cryllex – only your full name, email address and telephone number will be required. Any payments that exceed $800 USD in value or the daily 3 transaction threshold can be made following the completion of a simple identity verification procedure.
          </span>
        </div>
      </div>
      <div id="block_14" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">What KYC information does Cryllex collect from its Paying Customers (Payer)?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex Paying Customer’s only need to provide their full name, email address, telephone number and some form of ID for a quick ID verification.
          </span>
        </div>
      </div>
      <div id="block_15" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">What KYC information does Cryllex collect from its Merchants (Payee)?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex conducts KYC via an in-house KYC procedure that is designed to streamline the KYC experience for Cryllex Merchants (Payees) without sacrificing the security and integrity of Cryllex payments. Information ranges from basic company information to bank account information to shareholder information.
          </span>
          <span className='d-block mt-2'>
            Should any difficulties arise during the KYC process, Cryllex Customer Support is always available to help – simply reach out to us at helpdesk@cryllex.com and a representative will be at your assistance.
          </span>
        </div>
      </div>
      <div id="block_16" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">What if my verification process fails?</strong>
        <div className="cx--contact-info-text mt-2">
          <div>
            <span className='d-block'>
              If the verification process fails, it could be due to several reasons. Error messages will be displayed and will indicate reasons for failure. Common causes include, but are not limited to:
            </span>
            <ul>
              <li>
                <span>A mismatch of personal information listed on your identifying document and the information you manually submit to Cryllex</span>
              </li>
              <li>
                <span>The identification document submitted does not match your face</span>
              </li>
              <li>
                <span>The document is invalid or expired</span>
              </li>
              <li>
                <span>Poor photo quality</span>
              </li>
            </ul>
          </div>
          <span className='d-block mt-2'>
            Note that you must submit an ID that is valid. Expired identifying documentation will not be accepted.
          </span>
          <span className='d-block mt-2'>
            Please make adjustments to areas identified in the error message and resubmit. If further errors persist, please contact us at <a href="mailto:helpdesk@cryllex.com">helpdesk@cryllex.com.</a> We will get back to you as soon as possible.
          </span>
        </div>
      </div>
      <div id="block_17" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">How do I withdraw my Cryllex balance to my bank account?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            To make a withdrawal of your Cryllex funds to your bank account, simply head to the Payouts page under the Balance tab in the left sidebar of your Merchant Portal. There, you will be provided a simple breakdown of your Cryllex balance and withdrawal details – click “Create” and your balance should be settled to your bank account within 1 business day.
          </span>
        </div>
      </div>
      <div id="block_18" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">Where did the sum in my Cryllex balance go?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            If the Cryllex balance sum displayed in your Merchant Portal has reset to 0, chances are the Cryllex system has automatically initiated a Payout Request to the bank account linked to Cryllex. As a reminder, Cryllex balances that exceed $5000 USD are subject to daily payout to your bank account through an automated process.
          </span>
          <span className='d-block mt-2'>
            For future reference, keep an eye out when you log into your Merchant Portal for a message reminding and notifying you of the automatic Payout Request submission (when applicable).
          </span>
        </div>
      </div>
      <div id="block_19" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">Can I withdraw only part of my Cryllex balance to my bank account?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Presently, Cryllex Merchants are only able to withdraw the entire sum in their Cryllex balance per Payout Request. If your Cryllex balance does not exceed $5000 USD in value, you will have the option to accumulate your earnings up to the $5000 USD threshold. However, if you choose to submit a Payout Request before reaching the $5000 USD threshold, it must be for the full amount of your Cryllex balance.
          </span>
        </div>
      </div>
      <div id="block_20" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">How can I receive payment from my Paying Customer?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            To receive payment from your Paying Customer, simply head over to the Instant Payments tab in the side bar of your Merchant Portal and create an Instant Payment. Upon entering your Paying Customer’s information, a generated link/QR Code can be sent to your Paying Customer that will enable them to make payment.
          </span>
        </div>
      </div>
      <div id="block_21" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">What is the Flag Control Center on my Merchant Dashboard?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Within your Merchant Portal, some actions and/or changes require Cryllex Admin approval before they are made official (flags are typically handled on the same business day or at the start of the next business day). For instance, changes to your Bank Account Information.
          </span>
          <span className='d-block mt-2'>
            The Flag Control Center found in your Merchant Dashboard helps you keep track of the actions you have initiated that require Cryllex Admin Flag Handling. When items have been resolved by a Cryllex Admin, you will receive a notification in your Flag Control Center.
          </span>
        </div>
      </div>
      <div id="block_22" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">How do I close my Cryllex account?</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Given that Cryllex does not charge any account maintenance fees, Cryllex customers do not incur any costs for keeping their Merchant account open. With digital asset payments becoming increasingly common, Cryllex aims to enable Merchants to accept these payments as conveniently as possible.
          </span>
          <span className='d-block mt-2'>
            With that said, if you have any issues with your Merchant Portal simply send an email to us at <a href="mailto:helpdesk@cryllex.com">helpdesk@cryllex.com</a>  and a representative will be at your assistance.
          </span>
        </div>
      </div>

    </div>
  </div>
}

export const setPayingCustomerAgreementData = () => {
  return <div>
    <div className='px-3'>
      <div className="cx--contact-info-wrapper">
        <small className="d-block cx--contact-info-text">Cryllex Global Limited</small>
        <small className="d-block cx--contact-info-text">Last Updated: April 19, 2025</small>
        <small className="d-block cx--contact-info-text">Official Cryllex Document:</small>
        {/* <small className="d-block cx--contact-info-text"><b>Paying Customer Cryllex Terms of Use/Agreement</b></small> */}
      </div>

      <div id="block_1" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(0) Introduction</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            This Paying Customer Agreement (the "Agreement", "Terms") sets forth the respective rights and
            obligations between you and Cryllex Global Limited, a corporation formed under the laws of the British
            Virgin Islands ("Cryllex"). The term “Cryllex” will be used in this Agreement to refer to the Cryllex
            entity with which you will engage in a contractual relationship. As used herein, "you" and “your” refers to
            the individual or liable entity agreeing to the terms of this Agreement either in writing or via electronic
            acceptance; references to "we," "us," and "our" refer to Cryllex Global Limited.
          </span>
          <span className='d-block my-3'>
            This Agreement governs your use of the Cryllex Software Services, either directly or through the use of
            an authorized third-party, which you are using to make a payment to a Merchant ("Services"). By making
            a payment using the Services, you agree to be bound by the terms and conditions of this Agreement,
            including the arbitration clause and class action waiver.
          </span>
          <span className='d-block my-3'>
            By registering a Cryllex ID, accessing or using the Services, you agree to be legally bound by the terms
            and conditions of this Agreement in their entirety, including any terms incorporated by reference. Please
            read it carefully.
          </span>
          <span className='d-block my-3'>
            Nothing in these Terms should be construed as creating a partnership or joint venture of any kind between
            the parties and neither party will have the authority to bind the other party or to contract in the name of or
            create a liability against the other party in any way or for any purpose.
          </span>
          <span className='d-block my-3'>
            If you do not agree to any of these terms and conditions, including the mandatory arbitration provision,
            DO NOT register a Cryllex ID or access or use the Services.
          </span>
        </div>
      </div>
      <div id="block_2" className="cx--contact-info-wrapper mt-4">
        <div>
          <strong className="cx--section-title-lg d-block">(1.0) Scope of Services</strong>
          <strong className="cx--section-title-lg d-block mt-2">(1.1) Our Services</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              The Services may be made available to you via a third-party desktop, mobile, web application, the
              Cryllex web portal or API.
            </span>
            <div className='my-3'>
              You must not use or access the Services (including, but not limited to):
              <ol>
                <li>
                  In any way that is misleading or deceptive, infringes upon another person's rights (including
                  Intellectual Property Rights or Privacy Rights);
                </li>
                <li>
                  To copy, scrape or store any Content;
                </li>
                <li>
                  To modify or reverse engineer the API; or
                </li>
                <li>
                  Re-supply, re-sell, sub-license to any other person or alter any part of the Content except as
                  explicitly provided for in this Agreement.
                </li>
              </ol>
            </div>
            <span className='d-block my-3'>
              You acknowledge that Cryllex may monitor API activity from its own systems for the purpose of
              ensuring quality, improving the Cryllex Service, products and API, and ensuring compliance with these
              Terms.
            </span>
            <span className='d-block my-3'>
              The Services enable participating merchants or other businesses ("Merchant") to conveniently receive
              virtual assets payments (also known as "digital assets," "virtual currency," "cryptocurrency" and "digital
              currency") from you, the "Paying Customer" or "Payer" as payment for goods or services in any of the
              Supported Virtual Assets (defined below). The Services are only compatible with those merchants and
              businesses that accept virtual asset payments using Cryllex's services, either directly or through a thirdparty agent.
            </span>
            <span className='d-block my-3'>
              By using our Service, you acknowledge that Cryllex is not a Virtual Asset Service Provider as it is a
              software solution for Merchants to accept payments for their goods or services with Virtual Assets.
            </span>
            <span className='d-block my-3'>
              Cryllex Global Limited is an amalgam of software services designed for the convenience of seamless
              utilization of blockchain technologies. All transactions that fall within the scope of our Services are
              public, with "on-chain" data or through regulated fiat channels. Cryllex does not exclude the possibility of
              supporting or participating in economic and trade sanctions programs administered by the United Nations,
              the Office of Foreign Assets Control (OFAC) of the United States Department of the Treasury, the USA
              PATRIOT Act, and other anti-money laundering (AML) and anti-terrorist financing (ATF) laws.
            </span>
            <span className='d-block my-3'>
              As required by applicable laws and regulations, Cryllex Global Limited maintains a comprehensive
              AML/ATF/Sanctions compliance program integrated within the software for Merchants and third-party
              licensed payment service providers including "Agents" (also known as "Money Service Providers",
              "Payment Service Providers" or generally any company or organization licensed or regulated to process
              payments either in Virtual Assets or Fiat currencies).
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg">(1.1.1) Transactions, Settlement and Custody </strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              You understand and acknowledge that while Cryllex may provide the necessary technology infrastructure
              to simplify the use of decentralized blockchain infrastructure for Merchants (through non-custodial
              integrations to blockchain infrastructure via APIs, automated instructions, transactional instructions, and
              transaction record keeping), Cryllex does not at any point process or take custody of any virtual asset or
              fiat currency, on your behalf, within the scope of our Services. Furthermore, you understand and
              acknowledge that all virtual assets and fiat currencies are transacted and settled by Agent(s) available to
              the Merchant.
            </span>
            <span className='d-block my-3'>
              You acknowledge and understand that Cryllex is not a party to the contract between you and the
              Merchant. Cryllex acts as a software that facilitates the use of blockchain networks and is not a party to
              any agreement to buy, sell or provide goods or services.
            </span>
            <span className='d-block my-3'>
              Other than the specific obligations expressly set out in these Terms, Cryllex is not responsible or liable to
              you for any failure by a Payer or Merchant to comply with these Terms or any other legal obligations, or
              for any obligations that you and/or the Payer are required to perform.
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg">(1.1.2) Cost Calculation Engine</strong>
          <div className="cx--contact-info-text mt-2">
            <div>
              <span>
                To ensure that the correct price is represented for the goods and services being sold by the Merchant,
                Cryllex services includes a Cost Calculation Engine, acting in good faith and in a commercially
                reasonable manner to make determinations related to any price adjustments, obligations, disruptions,
                valuations, exchange rates, and settlements that occur throughout the duration of a transaction involving
                virtual assets and fiat currencies. When you or the Merchant are using our Services to transact, Cryllex
                shall calculate the transaction costs for the Merchant using the following information:
              </span>
              <ol>
                <li>
                  Blockchain related fees, including on-chain blockchain transaction fee approximations and onchain bridging fee approximations, sampled from the prevailing fees indicated on public portals
                  prior to the transaction execution;
                </li>
                <li>
                  Virtual asset off-ramp (virtual asset to fiat) conversion fees provided by participating exchanges,
                  liquidity provider(s) and/or Agents designated by the Merchant;
                </li>
                <li>
                  Fiat settlement fees, including, but not limited to, telegraphic transfer costs, global transaction
                  fees, SWIFT fees, local banking fees and/or foreign exchange conversion fees by Agents.
                </li>
              </ol>
            </div>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg">(1.1.3) Tax Reporting</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              You understand and agree that Cryllex is not required to provide any tax forms or reports related to your
              activity on or through Cryllex. You are solely responsible for any taxation obligations.
            </span>
            <span className='d-block my-3'>
              Cryllex reserves the right to give you the option to receive proof of transactions, including merchant
              receipts, generated by our Services and transaction records, or reports, related to your Cryllex
              transactions. The type of document you receive may depend on the jurisdiction in which you are located.
            </span>
            <span className='d-block my-3'>
              You will not hold Cryllex liable or responsible for any information provided to you on any document you
              receive from Cryllex. You further understand that you are ultimately and solely responsible for
              determining, reporting, and paying any tax liability incurred by your activity within the scope of our
              Services.
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg">(1.1.4) Cryllex ID</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              During the payment verification process (See Section 3) you as the Payer will receive a Cryllex Paying
              Customer ID, unique to your name and mobile phone number provided at the transaction Checkout
              Window. A Cryllex ID is a system-generated identification number used to maintain a record of the
              transactions to a Merchant. It is automatically generated and tied to all entities involved in usage of the
              Services (Paying Customer, Merchants, Agents), along with other personal information and
              documentation gathered during the confirmation processes required for accessing the Services. The usage
              of “Cryllex ID” throughout this document is a broad reference to the Cryllex ID assigned to each entity
              involved in any transaction via Cryllex – the Paying Customer, Merchant and Agent.
            </span>
          </div>
        </div>
        <div className="mt-3">
          <strong className="cx--section-title-lg d-block">(1.2) Eligibility</strong>
          <strong className="cx--section-title-lg d-block mt-2">(1.2.1) Entities</strong>
          <div className="cx--contact-info-text mt-2">
            <div>
              <span>
                To use the Services, you must be an entity duly formed and legally authorized to operate in the
                jurisdiction of your formation ("Entity"). If you are registering or using the Services on behalf of a legal
                entity, you represent and warrant that:
              </span>
              <ol>
                <li>
                  Said legal entity is duly organized and validly existing under the Applicable Laws of its
                  jurisdiction; and
                </li>
                <li>
                  You are duly authorized by said legal entity to act on its behalf.
                </li>
              </ol>
            </div>
            <div>
              <span>
                You further represent and warrant that you:
              </span>
              <ol>
                <li>
                  Have not previously been suspended or removed from using the Services; and
                </li>
                <li>
                  Have all powers and authority necessary to enter into this Agreement and in doing so will not
                  violate any other agreements to which you are a party.
                </li>
              </ol>
            </div>
            <span className='d-block my-3'>
              Cryllex is not responsible or liable for relying on the representations of your agents, employees,
              contractors, attorneys, financial advisors, or any other person Cryllex reasonably believes represents you
              in the acceptance of this Agreement or in the acceptance of any other instruction provided through the
              Services offered.
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg">(1.2.2) Services and Your Location</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              By using the Services, you are establishing a contractual relationship with Cryllex Global Limited (a BVI
              company). You understand and agree that the Services made available to you may be limited depending
              on the Jurisdiction you are accessing the Services from, and Cryllex reserves the right to restrict the
              Services made available to you based on the credibility of your wallet and location, determined through
              your mobile number or your IP address. You further understand and agree that the Services may be
              limited or terminated if you are located in or move to a jurisdiction that is not supported by Cryllex.
              Cryllex shall not be liable to you for any claims related to the limitation or termination of the Services
              based on your location. You shall hold Cryllex harmless for any actions taken by Cryllex resulting from
              your moving to a new jurisdiction or accessing the Services from an unsupported jurisdiction.
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg d-block mt-2">(1.2.3) Restricted Jurisdictions</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              You may not register to use the Services if you are located or organized in, under the control of, or
              resident of any state, country, territory, or other jurisdiction to which the United Nations has sanctioned or
              embargoed goods or services, or where your use of the Services would be illegal or otherwise violate any
              applicable law of such jurisdiction or of the United Nations ("Restricted Jurisdiction"). We may
              implement controls to restrict access to the Services from any Restricted Jurisdiction. You hereby
              represent and warrant that you are not under the control of, or resident of, any Restricted Jurisdiction and
              that you will not access or use any Services while located in any Restricted Jurisdiction, even if the
              safeguards to our Services from these jurisdictions are proven ineffective.
            </span>
          </div>
        </div>
      </div>
      <div id="block_3" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(2.0) Making a Payment</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            When you choose to make a payment using the Services, you will be redirected to the Cryllex Checkout
            Window where you will have the option to make selections that are necessary to execute the transaction.
            Whether you are making payment via Instant Payments or ECommerce Checkout, you will be redirected
            to the same payment window.
          </span>

          <span className='d-block my-3'>
            At the Checkout Window, you will be presented with the Merchant Invoice Price, the commission
            charged, and the total amount to be paid, among some other transaction-specific information.
          </span>
          <span className='d-block my-3'>
            Payments must be completed within the Payment Period, guided by the timer on the Checkout Window,
            or the invoice will expire. Payments made to expired invoices cannot complete an invoice or purchase,
            deemed Orphan Payments (defined below). Do not send a payment to an expired invoice. You agree not
            to hold Cryllex liable or responsible for any payment lost to any form of an expired invoice.
          </span>
          <span className='d-block my-3'>
            If an invoice expires, you must generate a new invoice by restarting the checkout process. The new
            invoice will provide a new Payment Period and an updated payment amount based on any new alterations
            detected by our Cost Calculation Engine since your prior, expired, invoice.
          </span>
        </div>

        <div>
          <strong className="cx--section-title-lg">(2.1) Prohibited Activities</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              When accessing and using the Services, you must not (non-exhaustive):
            </span>
            <ol>
              <li>Provide incorrect, incomplete or inaccurate information;</li>
              <li>Make any payments that are inconsistent with your legal and lawful intent;</li>
              <li>Impersonate another person or misrepresent authorization to act on behalf of others;</li>
              <li>Misuse the Services in any way which may impair the functionality of the underlying systems or
                impair the ability of any other to use the Services; and</li>
              <li>
                Attempt to view, access or copy any material or data other than that which you are authorized to
                access.
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div id="block_4" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg d-block">(3.0) User Registration</strong>
        <strong className="cx--section-title-lg d-block mt-2">(3.1) Information Required to Access Services </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Information that we collect from you will be detailed to you upon accessing the Services. Cryllex may, in
            its sole discretion, dictate the exact information required or ask for more information before allowing you
            to proceed with accessing the Services.

          </span>
        </div>

        <div>
          <strong className="cx--section-title-lg d-block mt-2">(3.1.1) Personal Information</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              For individuals, before accessing the Services, you must provide Cryllex with information and
              documentation that is requested for the purpose of establishing and verifying your identity ("Personal
              Information"). Personal Information includes, but is not limited to, your name, email address and phone
              number. Personal Information may also include documentation, such as copies of your government-issued
              photo identification (for example, your passport, driver's license, or military identification card), to
              confirm your identity and eligibility to use the Services.
            </span>
            <span className='d-block my-3'>
              Personal Information will be retained by us at our discretion and may be made available to any law
              enforcement, government, authority or regulator upon reasonable request in accordance with applicable
              laws and regulations. You agree to provide accurate, current, and complete Personal Information.
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg">(3.1.1.1) Personal Information Required for Transactions</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              In paying an invoice or within an e-commerce platform, you understand and agree that you will be
              required to provide Cryllex with your email address and/or SMS compatible phone number. Some
              Merchants may require Cryllex to collect your name and physical address during the payment process to
              fulfill certain legal and compliance obligations. Your email address and/or SMS compatible phone
              number will be used for certain payment and/or refund communications and therefore must be your valid
              email address and/or SMS compatible phone number.
            </span>
            <span className='d-block my-3'>
              Cryllex will additionally automatically collect information including, but not limited to, wallet history, IP
              address, geographic location, item being purchased, and transaction amount. Cryllex collects this
              information subject to its Privacy Notice, published on our website.
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg">(3.1.1.2) Personal Information Required for Transactions Exceeding a Specified Threshold</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              Merchants and Agents are required by local laws and regulations to collect certain information about you
              for transactions and refunds over a certain size and, in some regions, for any transaction. Our systems
              integrate this function on behalf of Merchants and Agents. You understand and agree that you may be
              required to undergo an additional verification process conducted through a third-party identity verification
              provider. Furthermore, you understand that in doing so, you will be subject to a separate set of terms
              made available to you by that third-party identity verification provider. For simplicity, any information
              we require as outlined in Sections 3.1.1 and 3.1.2 will be referred to as "Background Information."
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg d-block mt-2">(3.1.1.3) Threshold Determination</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              This transaction threshold is a system setting determined and adjusted to the lower value required by a
              given Merchant and their respective Agents. Cryllex also reserves the right to make appropriate
              adjustments to the transaction threshold level.
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg d-block mt-2">(3.1.2) Entity Information</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              During the Cryllex ID registration process for entities, you must provide Cryllex with information and
              documentation that is requested for the purpose of establishing and verifying your entity information
              ("Entity Information"). Entity Information may include, but is not limited to, the name, email address,
              phone number, date of birth, and taxation identification number of each of the ultimate beneficial owners,
              controlling persons or directors ("UBO"), in addition to the entities corporate tax identification number
              and incorporation documents, certificate of incumbency, certificate of good standing, or other corporate
              information and documentation as applicable and requested by Cryllex on behalf of the Merchant or the
              Merchant's preferred Agent. Entity Information will be retained by Cryllex on behalf of the Merchant and
              Agent for a minimum statutory period of seven (7) years and may be made available to any law
              enforcement, government body, authority or regulator upon reasonable request in accordance with
              applicable laws and regulations. You agree to provide accurate, current, and complete Entity Information.
              Herein, Personal Information and Entity Information shall collectively be referred to as "Background
              Information."
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg d-block mt-2">(3.2) Verification</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              You hereby authorize Cryllex, or a third-party service provider that we designate, to take any measures
              we consider necessary to maintain continual confirmation of the Background Information you provide,
              verify and authenticate your Background Information, and take any action deemed necessary based on the
              results on behalf of Merchants and Agents. You acknowledge that this process may result in a delay in
              accessing our Services, and that you will not be authorized to do so until your Cryllex ID registration has
              been successfully completed.
            </span>
          </div>
        </div>
      </div>
      <div id="block_5" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg d-block">(4.0) Cryllex ID Management</strong>
        <strong className="cx--section-title-lg d-block mt-2">(4.1) Cryllex ID Maintenance</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            You are solely responsible for keeping the information associated with your Cryllex ID updated at all
            times. In the case that information and documentation previously provided by you, as an individual or an
            entity, has expired or has changed, you shall be required to make the necessary amendments in a timely
            manner or go through the registration process again. You understand that a change in the geographical
            location of residence may impact your eligibility to access and use the Services.
          </span>
          <span className='d-block my-3'>
            As part of our legal compliance service ("AML Program") offered to Merchants and Agents, we will
            monitor your Cryllex ID and your use of the Services and review your Background Information and any
            transaction related activity on an ongoing basis, as may be required by law and/or pursuant to a
            Merchant's or Agent's internal policies and procedures. We may, at any time, require you to provide us
            with additional Background Information, or any other information reasonably requested, as a condition to
            your continued access to and use of the Services. During such a time, your access to and use of the
            Services may be temporarily restricted until they satisfy the minimum requirements of the Merchant or
            Agent, whichever of the two is higher.
          </span>
        </div>

        <div>
          <strong className="cx--section-title-lg">(4.2) Potentially Fraudulent Activity</strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              Cryllex designs digital Anti-Money Laundering and Counter-Terrorist Financing policies on behalf of
              your Merchant and their designated Agent. These policies are designed to detect and prevent fraud or to
              identify and assess fraud-related risk. Cryllex shall monitor your use of the Services in accordance with
              the minimum risk parameters and thresholds established by Merchants or Agents, whichever of the two is
              higher. In the event of detection of fraudulent or suspicious activity, Cryllex systems are designed to
              restrict access to the Services, and further, is required to submit notice to the respective Merchant and/or
              Agent. Should the standard operating procedures be pre-defined and automated within the Cryllex system,
              the Merchant or Agent may have automated alerts established to the relevant authorities.
            </span>
            <div className='my-3'>
              <span>In the event of an investigation, you agree to:</span>
              <ol>
                <li>
                  Fully cooperate with the Merchant or Agent in such an investigation, with certain communication
                  and evidence gathering being done through Cryllex;
                </li>
                <li>
                  Complete any required affidavits promptly, accurately and thoroughly;
                </li>
              </ol>
            </div>
            <span className='d-block my-3'>
              You understand and acknowledge that any failure to cooperate in any such investigation may cause delays
              in regaining access to the Services.
            </span>
          </div>
        </div>
      </div>
      <div id="block_6" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg d-block">(5.0) Information Usage</strong>
        <strong className="cx--section-title-lg d-block mt-2">(5.1) Internal Information Use </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Background Information will be encrypted and stored on secure servers, and is only accessible by Agents,
            Merchants, and in the case of any suspected fraudulent activity, local authorities, law enforcement or
            regulators of the respective jurisdictions that the transaction has taken place in. At any time, you will have
            the ability to login to your Paying Customer Portal to view the transaction history associated with your
            Cryllex ID. From the portal, you may also choose to delete items from your transaction history; the
            individual transaction item will be removed as a visible line item only from your account. Cryllex
            maintains transaction records on behalf of Merchants and Agents for the minimum statutory period of
            seven (7) years.
          </span>
        </div>
        <div>
          <strong className="cx--section-title-lg d-block mt-2">(5.2) Authorization to Share Background Information </strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              Accessing our Services is an authorization by you, the Merchant and their designated Agent, and/or an
              applicable third-party, to access any of your Background Information, and to continue holding such
              information, including any revisions or additions thereto, with the Merchant, Agent and/or the applicable
              third-party, on an ongoing basis.
            </span>
            <span className='d-block my-3'>
              You understand that on behalf of the Merchant or their designated Agent, we may retain all user
              information, including activity related to the Services and Background Information, as required by this
              Agreement and local laws or regulations, and may share such information with a given jurisdiction's
              government agency, law enforcement, regulator or other third-party in order to verify the Background
              Information in accordance with Section 3 above.
            </span>
            <span className='d-block my-3'>
              For further information on how we use or share your Background Information and other information you
              provide us during the use of the Services, refer to the Cryllex Privacy Policy.
            </span>
          </div>
        </div>
        <div>
          <strong className="cx--section-title-lg">(5.3) Authorization to Share Transaction Information with Agent </strong>
          <div className="cx--contact-info-text mt-2">
            <span>
              If you are accessing our Services, you hereby authorize the Merchant to provide the Agent with
              information relating to your transaction, including but not limited to the transaction value, and
              Background Information.
            </span>
          </div>
        </div>
      </div>
      <div id="block_7" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(6.0) Supported Virtual Assets</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Software within the Services portfolio is designed to support several different virtual asset blockchain
            protocols ("Supported Virtual Assets"). The Merchant may choose to accept payments in all or a subset of
            the Supported Virtual Assets, and the Merchant is solely responsible for indicating which virtual assets
            they choose to accept for payment. Cryllex may, at its discretion, add or remove support for digital
            currencies from time-to-time as a technological support feature. Supported Virtual Assets are indicated
            through the selection available on the Cryllex Service and are updated on a regular basis.
          </span>
        </div>
      </div>
      <div id="block_8" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(7.0) Unsupported Payments</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Payments made using any virtual asset, token, coin or cryptocurrency other than the ones that Cryllex has
            listed as a Supported Cryptocurrency are "Unsupported Payments". Unsupported Payments cannot be
            applied to a Merchant invoice or e-commerce platform. You agree and understand that any Unsupported
            Payments sent to a temporary Merchant wallet may not be received, and Cryllex will be unable to
            facilitate access or recover such Unsupported Payments on behalf of the Merchant.
          </span>
          <span className='d-block my-3'>
            You agree to use only supported currencies to pay invoices or e-commerce portals. You are solely
            responsible for losses caused by any Unsupported Payments and acknowledge that Unsupported
            Payments may be lost and unable to be recovered or refunded. Cryllex also reserves the right to
            temporarily suspend refund processing of Unsupported Payments and/or other payments made using the
            Services. Cryllex, the Merchant or their designated Agent will not be held responsible or liable for any
            Unsupported Payment.
          </span>
        </div>
      </div>
      <div id="block_9" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(8.0) Transaction Fees</strong>
        <div className="cx--contact-info-text mt-2">
          <div>

            <span>
              You will incur certain fees in connection with making cryptocurrency payments when using the Payment
              Services. You will incur blockchain transaction fees such as gas fees and network costs as set forth in this
              Section. You will also incur Refund Fees on refunds, as set forth in Sections 7 and 9. You may also incur
              Cryllex's infrastructure utilization fees if the Merchant chooses to pass the fee through to you, as set forth
              in this Section:
            </span>
            <ol>
              <li>
                For blockchain protocols, transaction processing fees sometimes referred to as Gas Fees
                ("Network Fees") are fees required to broadcast on-chain cryptocurrency transactions to the
                relevant blockchain stakeholders, such that it will prioritize and process the transactions and
                maintain the integrity of the blockchain protocol. Network Fees are paid to certain blockchain
                stakeholders.
              </li>
              <li>
                Your cryptocurrency wallet will automatically deduct the Network Fees, that vary depending on
                network conditions and the desired speed needed for transaction confirmation. Low Network Fees
                have a higher risk of transaction de-prioritization or transaction failure during network
                propagation. Cryllex Services will estimate the Network Fees as "Provisional Fees" and apply
                them to the costs borne by you for the transaction other than when you use your wallet and
                authorize a transaction.
              </li>
              <li>
                Additional Network Fees are incurred after a transaction is received by the Merchant, while
                completing the transaction from the Merchant's temporary self-custodized segregated wallet to
                their designated Agent or designated off-ramp venue.
              </li>
              <li>
                When Network Fees exceed the equivalent of U.S.$0.01, they are included and listed on the
                Merchant Invoice or in the E-Commerce Checkout Payment Total, as well as in transaction
                documents and invoices labeled as a "Network Fee".
              </li>
              <li>
                Refunds will also attract Network Fees. Refund Fees are the costs, including Network Fees, that
                are incurred in refunding payments that have not yet been settled in Fiat Currencies or can be
                reversed by the Merchant. Refunds are virtual asset transactions and Refund Fees will be incurred
                for on-chain refunds (merchant wallet to customer wallet) and costs may differ significantly to
                off-chain refunds that typically involve Fiat Currency.
              </li>
              <li>
                Cryllex charges an Infrastructure Service Fee for providing its Services to Merchants and
                Customers. This fee is a percentage of the transaction value. Merchants add this Infrastructure
                Service Fee to the invoice quote in addition to the Network Fee and cost of the goods or services
                you are purchasing.
              </li>
              <li>
                Cryllex reserves the right to provision for Network Fees and other virtual asset conversion fees on
                behalf of the Merchant for each transaction to minimize volatility in expected sales proceeds that
                may occur while the virtual asset transaction is being processed through the network. The Risk
                Pricing Engine ("RPE") calculation software is a calculation methodology generally based on
                volatility metrics of the virtual asset including price volatility and Network Fees. The
                provisioning for volatility is included in the invoice or e-commerce platform price, charged by the
                Merchant to the customer. This Cryllex Micro-Service is designed to ensure the Merchant
                receives the full value of their goods or services amid certain volatile conditions. You agree that
                by using our Services, you do not hold Cryllex liable for price adjustments and/or variations made
                during your purchase due to the calculation methodology or the service provided to the Merchant
                to ensure stability in their transaction value. If you disagree with the pricing and costs, you have
                the choice not to proceed with the transaction prior to accepting the transaction. Cryllex retains
                the right to keep fee calculations and methods undisclosed.
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div id="block_10" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(9.0) Payment Exceptions: Underpayments, Overpayments, Orphan Payments </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            The term "Payment Exceptions", as used in these Paying Customer Terms, refers collectively to
            Underpayments, Overpayments and Orphan Payments, which are each defined below.
          </span>
        </div>
        <strong className="cx--section-title-lg d-block mt-2">(9.1) Underpayments </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Underpayments occur when insufficient funds are sent as payment for an invoice. Underpayments cannot
            fulfill an invoice (in whole or part), and Cryllex will notify you of the Underpayment via email and/or
            SMS message. You can claim a refund of the Underpayment from the invoice or the Underpayment
            notification message and agree to bear the Refund Fees if you make an Underpayment and will not hold
            Cryllex or the Merchant liable for the losses incurred during a refund. If an Underpayment occurs, you
            will need to generate a new invoice by restarting the checkout process. The new invoice will open a new
            Payment Window, and an updated payment amount will be displayed based on any changes to the Cost
            Calculation Engine.
          </span>
        </div>
        <strong className="cx--section-title-lg d-block mt-2">(9.2) Overpayments </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Overpayments occur when additional funds are sent beyond the amount needed to fully pay an invoice.
            With an overpayment, the funds required to pay the invoice will be remitted to the Merchant, and Cryllex
            will notify you via email and/or SMS messaging of the Overpayment amount. You may claim a refund of
            the Overpayment Difference (the amount in excess of the invoice amount) from the invoice or the
            notification message. Refunds of the Overpayment Difference will be subject to Refund Fees. You agree
            to not hold Cryllex or the Merchant liable for the losses incurred during a Refund.
          </span>
        </div>
        <strong className="cx--section-title-lg d-block mt-2">(9.3) Orphan Payments</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Late payments (i.e. payments made after the expiration of a Payment Window), and payments made to a
            Merchant wallet address that is not associated with any known invoice through an active Payment
            Window are called "Orphan Payments". By making an Orphan Payment, you acknowledge that Cryllex or
            the Merchant cannot be held liable for potential losses, despite our best-effort procedures to recover the
            virtual assets missent. You understand that Cryllex cannot automatically associate an Orphan Payment
            with an email address or SMS capable phone number and as such, we are unable to notify you to claim a
            refund. Instead, you will need to contact Cryllex to request support for an Orphan Payment.
          </span>
          <span className='d-block my-3'>
            You will be asked to cooperate and provide the Cryllex Support Team with additional information to
            identify and support the refund of your Orphan Payment. Cryllex Services cannot apply an Orphan
            Payment to a new invoice. If an Orphan Payment occurs, a new invoice will need to be generated and a
            timely payment in a Supported Virtual Asset will need to be executed to fulfill that payment. If you do
            not provide Cryllex Customer Support with the requested additional information, Cryllex may not be able
            to support the refund of the Orphan Payment to you.
          </span>
        </div>
      </div>
      <div id="block_11" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(10.0) Additional Payment Review</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            From time to time, Cryllex Services will be deployed, on behalf of the Merchants and Agents you have
            agreed to transact with, to perform additional reviews of select transactions. Such reviews may be
            required due to a Merchant's usage of Cryllex's Anti-Money Laundering and Sanctions Compliance
            Services. There will also be occasions where the designated Agents of Merchants, that interact directly
            with their banking partners, may require additional data on transactions. Such payment reviews are most
            common with suspicious transactions.
          </span>
          <span className='d-block my-3'>
            Whenever possible, the Merchant will use our Services to provide prompt notice to you if additional
            payment review is required through the email address and/or SMS compatible phone number you provide
            at the Checkout Window.
          </span>
          <span className='d-block my-3'>
            Additional information may be required from you in connection with such a review, and such information
            will be subject to Cryllex's Privacy Policy. You agree to cooperate with requests for such additional
            information and acknowledge the request comes from the Merchant and/or Agent. If you fail to provide
            the required information, you acknowledge that we will be unable to complete your transaction and that
            Cryllex will not be liable for the failure of the transaction.
          </span>
        </div>
      </div>
      <div id="block_12" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(11.0) Wallet Security</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex includes a Non-Custodial Software Micro-Service for Merchants and their designated Agents;
            Merchants and Agents will have full control over the access and security of their respective wallets used
            to process your Payment, including the capacity to terminate their wallets.
          </span>
          <span className='d-block my-3'>
            Cryllex will never request your cryptocurrency wallet recovery keys, passphrases or security keys, and
            none of these are required to make a payment using the Services. You are solely responsible for
            maintaining the security of your cryptocurrency wallet, including ensuring that the devices on which you
            maintain and/or access your cryptocurrency wallet are free from viruses, malware or other compromising
            code.
          </span>
          <span className='d-block my-3'>
            By using this Service, you acknowledge that Cryllex is not responsible for the non-fulfillment of your
            purchase, however we may use a best-effort basis to support law enforcement for investigation into fraud
            or theft by a Merchant or other external party
          </span>
        </div>
      </div>
      <div id="block_13" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(12.0) Disclaimers</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICES ARE
            PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
            INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANT ABILITY, FITNESS
            FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL CRYLLEX
            OR ITS AFFILIATES BE LIABLE FOR ANY CLAIM, DAMAGES, OR OTHER LIABILITY,
            WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF
            OR IN CONNECTION WITH THE PAYMENT SERVICES, REGARDLESS OF WHETHER
            CRYLLEX OR ITS AFFILIATES KNEW OR HAD REASON TO KNOW OF SUCH CLAIM,
            DAMAGES OR LIABILITY.
          </span>
          <span className='d-block my-3'>
            IN NO EVENT WILL CRYLLEX OR ITS AFFILIATES BE LIABLE FOR ANY USE,
            INTERRUPTION, DELAY OR INABILITY TO USE THE PAYMENT SERVICES, OR ANY
            INDIRECT, CONSEQUENTIAL, SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES,
            INCLUDING, WITHOUT LIMITATION, LOST REVENUES OR PROFITS, LOSS OF GOODWILL,
            LOSS OR CORRUPTION OF DATA, WHETHER ARISING OUT OF OR IN CONNECTION WITH
            THESE PAYING CUSTOMER TERMS, BREACH OF CONTRACT, TORT (INCLUDING
            NEGLIGENCE) OR OTHERWISE, REGARDLESS OF WHETHER SUCH DAMAGES WERE
            FORESEEABLE AND WHETHER OR NOT WE WERE ADVISED OF THE POSSIBILITY OF SUCH
            DAMAGES. FOR CUSTOMERS CONTRACTING WITH CRYLLEX, WHILE CRYLLEX
            DISCLAIMS LIABILITY FOR LOST PROFITS AND INDIRECT DAMAGES, CRYLLEX DOES
            NOT OTHERWISE EXCLUDE ITS LIABILITY FOR ITS GROSS NEGLIGENCE OR WILLFUL
            MISCONDUCT.
          </span>
        </div>
      </div>
      <div id="block_14" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(13.0) Limitation of Liability </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, YOU ACCESS AND USE THE CRYLLEX
            SERVICE AT YOUR OWN RISK. IN NO EVENT SHALL WE, OUR RESPECTIVE OFFICERS,
            DIRECTORS, EMPLOYEES BE LIABLE OR RESPONSIBLE TO YOU OR ANY THIRD PARTY
            FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAAL OR EXEMPLARY
            DAMAGES, WHETHER FORESEEABLE OR NOT, UNDER CONTRACT OR TORT, INCLUDING
            DAMAGES FOR LOSS OF PROFITS, LOSS OF BUSINESS, REVENUE, USE, DATA, MONEY,
            GOODWILL, REPUTATION OR OTHER ECONOMIC ADVANTAGE, EVEN IF WE ARE AWARE
            OF OR ADVISED OF THE POSSIBILITY FO THE SAME, ARISING OUT OF OR IN CONNECTION
            WITH OUR WEBSITE OR THE CRYLLEX SERVICE OR THESE TERMS.
          </span>
          <span className='d-block my-3'>
            IF YOU ARE DISSATISFIED WITH ANY PART OR THE WHOLE OF THE CRYLLEX SERVICE,
            BEYOND ANY COMPLIMENTARY EFFORT BY CRYLLEX TO HELP RESOLVE YOUR
            DISSATISFACTION, YOUR SOLE REMEDY IS TO DISCONTINUE USE OF THE CRYLLEX
            SERVICE.
          </span>
          <span className='d-block my-3'>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW AND ONLY TO THE EXTENT THE
            PREVIOUS PARAGRAPH DOES NOT APPLY, IF WE ARE LIABLE FOR ANY LOSS OR
            DAMAGES DESPITE THE PROVISIONS IN THESE TERMS, YOU AGREE THAT NO ACTION,
            WHATEVER ITS FORM, MAY BE BROUGHT BY YOU MORE THAN ONE YEAR AFTER THE
            EVENT WHICH GAVE RISE TO YOUR CLAIM. IN NO EVENT SHALL CRYLLEX'S
            CUMULATIVE LIABILITY TO YOU EXCEED THE LESSER OF (A) THE AMOUNT OF ITS
            PROFITS MADE FROM THE PAYMENT GIVING RISE TO OR ASSOCIATED WITH THE
            APPLICABLE CLAIM, OR (B) FIVE HUNDRED U.S. DOLLARS (US$500).
          </span>
        </div>
      </div>
      <div id="block_15" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg d-block">(14.0) Governing Law, Arbitration and Class Action Waiver</strong>
        <strong className="cx--section-title-lg d-block mt-2">(14.1) Initial Resolution Effort </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            We understand that disputes can arise in the course of transactions. If you, as a Paying Customer, have a
            concern or dispute regarding a transaction, we encourage you to first attempt to resolve the issue directly
            with the Merchant. Most disputes can be resolved at this stage.
          </span>
          <span className='d-block my-3'>
            If you are unable to resolve your dispute with the Merchant, or if your issue is directly with Cryllex
            Services, fill out a Customer Support Ticket via our webpage or contact our Customer Support Team at&nbsp;
            <a href="mailto:helpdesk@cryllex.com">helpdesk@cryllex.com</a>.
          </span>
          <div className='my-3'>
            <span>
              If you are contacting us via email, please provide:
            </span>
            <ol>
              <li>Your name and email address;</li>
              <li>A detailed description of the issue;</li>
              <li>Any relevant transaction details (e.g., transaction number, date, and amount);</li>
              <li>What resolution you are seeking.</li>
            </ol>
          </div>
          <span className='d-block my-3'>
            Our Customer Support team will investigate your dispute and aim to resolve it in a timely manner,
            typically within 30 days.
          </span>
        </div>
        <strong className="cx--section-title-lg">(14.2) Mediation</strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Should the issue not be resolved through Customer Support, we offer a mediation process as the next step.
            Mediation will involve a neutral third party to facilitate resolution between you and the other party (either
            the Merchant or Cryllex). This step is voluntary, but it can be a faster, less formal way to resolve disputes
            than arbitration.
          </span>
        </div>
        <strong className="cx--section-title-lg d-block mt-2">(14.3) Governing Law </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Any disputes arising out of or related to these Terms and Conditions of the use of The Services will be
            governed by the laws of British Virgin Island, without regard to its conflict of law principles.
          </span>
        </div>
      </div>
      <div id="block_16" className="cx--contact-info-wrapper mt-4">
        <strong className="cx--section-title-lg">(15.0) Modification to this Agreement </strong>
        <div className="cx--contact-info-text mt-2">
          <span>
            Cryllex reserves the right to update this Agreement at any time and at our sole discretion. If changes are
            made, we will post the amended Agreement to our website. In some instances, upon an update to these
            Terms, Cryllex may notify you via email, push notification and/or website pop-up. By using the Services,
            you accept the then effective Terms. If any provision of these Terms is deemed invalid or unenforceable
            under applicable law, then that provision shall be conformed to law to achieve the original intent to the
            extent possible. If the provision cannot be conformed, it shall be struck from these Terms to the extent
            necessary, and all other provisions shall remain in full force and effect. Any failure to enforce any
            provision of these Terms on any occasion shall not act as a waiver on that or any other occasion of that or
            any other provision. As to their subject matter, these Terms (including any other terms or notices
            incorporated herein by reference) comprise the entire agreement between you and Cryllex.
          </span>
        </div>
      </div>


    </div>
  </div>
}